initJsCookie();

/**
 * @typedef {{
 *   get: (cookieName: string) => string,
 *   set: (cookieName: string, cookieValue: string, options: { expires: number }) => void,
 * }} JSCookie
 *
 * @typedef {{
 *   _: any,
 *   jsCookie: JSCookie,
 *   utmInitialized: boolean,
 * }} Data
 *
 * @type {Data}
 */
const data = {
	utmInitialized: false,
	_: window._,
	jsCookie: window.jsCookie || {
		get: () => "N/A",
		set: () => undefined,
	},
}

